export default __webpack_public_path__ + "static/media/CORE_gstd.8fd37bac.png";